export const userDetailsConfig = {
    columns:[
        {headerName:"Request ID",mappedValue:"id"},
        {headerName:"Cheque",mappedValue:"checkLeafURL"},
        {headerName:"Authorization Letter",mappedValue:"authorizationLetter"},
    ]
}